import { TutorialStep } from 'src/replicant/tutorial/tutorial.ruleset';
import { TutorialEvent } from '../TutorialController';
import OrdinaryTutorial from './OrdinaryTutorial';
import { showTutorial } from '../tutorial.util';
import StateObserver from 'src/StateObserver';
import { decorationsActions } from 'src/game/decoration/decoration.redux';

export class BumBumTutorial extends OrdinaryTutorial {
  public readonly step: TutorialStep = 'bumbum';

  public async handleEvent(event: TutorialEvent): Promise<boolean> {
    if (event !== 'bumbumStarted') {
      return false;
    }

    // Show tutorial popup and grant rewards
    await showTutorial('bumbum', {
      $stepIndex: 40,
      $stepName: 'bumbum',
    });

    StateObserver.dispatch(decorationsActions.setTutorialDialogWasShown(true));

    return true;
  }
}
